<template>
  <Modal mayCancel="true" v-on:done="onCancel" v-on:cancel="onCancel">
    <h2>{{ title }}</h2>
    <p>{{ prompt }}</p>
    <div class="ButtonRow_Right">
      <button class="WBMBigButton" v-on:click="onCancel">Cancel</button>
      <button class="WBMBigButton m-primary" v-on:click="onOK">OK</button>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Component, Vue, Emit, Prop } from "vue-property-decorator";
import Modal from "@/components/Modal.vue";
import { ModalMutations } from "@/store/modules/modal";

@Component({ components: { Modal } })
export default class OKCancelModal extends Vue {
  @Prop() title!: string;
  @Prop() prompt!: string;

  @Emit("ok")
  onOK() {
    ModalMutations.closeModals(this.$store.commit);
  }

  @Emit("cancel")
  onCancel() {
    ModalMutations.closeModals(this.$store.commit);
  }
}
</script>

<style scoped lang="scss">
h2 {
  margin-top: 0;
}

.ButtonRow_Right {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > * {
    display: block;
  }
}
</style>
